import { useEffect, useState } from "react";

import { onTestAssignment } from "../../Services/testAssignmentStream";
import { auth } from "../../Core/utils/auth";
import { openTestWeb } from "../GuestUserDashboard/helpers";
import { AssignedTestPopup } from "../SPDashboard/components/UpcomingClasses/components/AssignedTestPopup/AssignedTestPopup";

/**
 * App-root listener for real-time `test_assigned` SSE events. Renders the shared
 * AssignedTestPopup globally (one instance) whenever a mentor assigns a test. It is
 * a passive listener — it never opens the SSE connection (the ongoing class card
 * owns that, so the stream runs only while a class is happening now). The popup is
 * dismissible once per assignment; a new assignment (different configId) re-opens
 * it, while a reconnect replay of the same one does not.
 */
export const TestAssignmentNotifier = () => {
  const [assignedTest, setAssignedTest] = useState(null);
  const [dismissedConfigId, setDismissedConfigId] = useState(null);

  useEffect(() => {
    if (!auth()) return undefined;
    return onTestAssignment((payload) => {
      if (payload?.event !== "test_assigned") return;
      setAssignedTest({ testConfigId: payload.configId ?? null });
    });
  }, []);

  const testConfigId = assignedTest?.testConfigId ?? null;
  const isOpen = !!assignedTest && dismissedConfigId !== testConfigId;

  const dismiss = () => setDismissedConfigId(testConfigId);

  // Returns whether navigation was initiated so the popup can keep/reset its
  // loading state. We do NOT dismiss here: on success the page unloads (keeping
  // the spinner visible until it does); on failure the popup stays so the user
  // can retry / see the error toast.
  const handleStartTest = () => {
    if (!testConfigId) return false;
    return openTestWeb(testConfigId);
  };

  return (
    <AssignedTestPopup
      open={isOpen}
      onClose={dismiss}
      onStartTest={handleStartTest}
    />
  );
};

export default TestAssignmentNotifier;
